var map = {
	"./fcb-logo-cn.png": "4049",
	"./fcb-logo-en.png": "bddf9",
	"./fcb-logo-ja.png": "0b36",
	"./fcb-logo-ko.png": "e2f8",
	"./fcb-logo-th.png": "8b0b",
	"./fcb-logo-tw.png": "5bcc6",
	"./fcb-logo-ug.png": "1698",
	"./fcb-logo-vn.png": "18e7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "595b";